import React from 'react';
import { strings } from '../../../../resources/strings';
import { DiagnosticInformation } from '../../../../models/DiagnosticInformation';
import { MultifocalInfo } from '../../../../models/MultifocalInfo';
import { Field, FieldType } from '../../../../common-components/Field/Field';
import { FormRecipeValues } from '../FormRecipe';
import { CardDiagnostic, TableDiagnostic, TableBodyDiagnostic, TableRowDiagnostic, TableColumnDiagnostic } from './styles';

interface TabDiagnosticProps {
    multifocal?: boolean;
    values?: FormRecipeValues;
    change: (values: FormRecipeValues) => void;
}

const TabDiagnostic: React.FC<TabDiagnosticProps> = ({
    multifocal,
    values,
    change
}) => {

    return (
        <>
            <CardDiagnostic borderBottom>
                <TableDiagnostic>
                    <TableBodyDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.Far}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.Spherical}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.Cylindrical}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.Axis}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.DNP}</TableColumnDiagnostic>
                        </TableRowDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.RightEyeAcronym}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.rightSpherical}
                                    change={(value) => changeFarDiagnosticRightSpherical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.rightCylindrical}
                                    change={(value) => changeFarDiagnosticRightCylindrical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.rightAxis}
                                    change={(value) => changeFarDiagnosticRightAxis(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.rightNasoPupillaryDistance}
                                    change={(value) => changeFarDiagnosticRightDNP(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                        </TableRowDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.LeftEyeAcronym}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.leftSpherical}
                                    change={(value) => changeFarDiagnosticLeftSpherical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.leftCylindrical}
                                    change={(value) => changeFarDiagnosticLeftCylindrical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.leftAxis}
                                    change={(value) => changeFarDiagnosticLeftAxis(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.farDiagnostic?.leftNasoPupillaryDistance}
                                    change={(value) => changeFarDiagnosticLeftDNP(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                        </TableRowDiagnostic>
                    </TableBodyDiagnostic>
                </TableDiagnostic>
            </CardDiagnostic>

            <CardDiagnostic borderBottom>
                <TableDiagnostic>
                    <TableBodyDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.Near}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.Spherical}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.Cylindrical}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.Axis}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>{strings.DNP}</TableColumnDiagnostic>
                        </TableRowDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.RightEyeAcronym}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.rightSpherical}
                                    change={(value) => changeNearDiagnosticRightSpherical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.rightCylindrical}
                                    change={(value) => changeNearDiagnosticRightCylindrical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.rightAxis}
                                    change={(value) => changeNearDiagnosticRightAxis(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.rightNasoPupillaryDistance}
                                    change={(value) => changeNearDiagnosticRightDNP(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                        </TableRowDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.LeftEyeAcronym}</TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.leftSpherical}
                                    change={(value) => changeNearDiagnosticLeftSpherical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.leftCylindrical}
                                    change={(value) => changeNearDiagnosticLeftCylindrical(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.leftAxis}
                                    change={(value) => changeNearDiagnosticLeftAxis(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.nearDiagnostic?.leftNasoPupillaryDistance}
                                    change={(value) => changeNearDiagnosticLeftDNP(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                />
                            </TableColumnDiagnostic>
                        </TableRowDiagnostic>
                    </TableBodyDiagnostic>
                </TableDiagnostic>
            </CardDiagnostic>

            <CardDiagnostic borderBottom={multifocal}>
                <TableDiagnostic>
                    <TableBodyDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'>{strings.Height}</TableColumnDiagnostic>
                            <TableColumnDiagnostic width='23.3%'>{strings.LeftEye}</TableColumnDiagnostic>
                            <TableColumnDiagnostic width='23.3%'>{strings.RightEye}</TableColumnDiagnostic>
                            <TableColumnDiagnostic></TableColumnDiagnostic>
                        </TableRowDiagnostic>
                        <TableRowDiagnostic>
                            <TableColumnDiagnostic width='60px'></TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.leftEyeHeight}
                                    change={(value) => changeLeftEyeHeight(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                    maxLength={2}
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic>
                                <Field 
                                    type={FieldType.Text}
                                    value={values?.rightEyeHeight}
                                    change={(value) => changeRightEyeHeight(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                    maxLength={2}
                                />
                            </TableColumnDiagnostic>
                            <TableColumnDiagnostic></TableColumnDiagnostic>
                        </TableRowDiagnostic>
                    </TableBodyDiagnostic>
                </TableDiagnostic>
            </CardDiagnostic>

            {multifocal ? (
                <CardDiagnostic>
                    <TableDiagnostic>
                        <TableBodyDiagnostic>
                            <TableRowDiagnostic>
                                <TableColumnDiagnostic width='60px'>{strings.Addition}</TableColumnDiagnostic>
                                <TableColumnDiagnostic width='23.3%'><Field 
                                    type={FieldType.Text}
                                    value={values?.multifocalInfo?.addField}
                                    change={(value) => changeAdditional(value)}
                                    marginRight='0px' marginTop='0px' marginBottom='px'
                                /></TableColumnDiagnostic>
                                <TableColumnDiagnostic></TableColumnDiagnostic>
                            </TableRowDiagnostic>
                        </TableBodyDiagnostic>
                    </TableDiagnostic>
                </CardDiagnostic>
            ) : null }
        </>
    );

    function changeAdditional(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
        values.multifocalInfo.addField = value;
        change({...values});
    }

    function changeFarDiagnosticRightSpherical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.rightSpherical = value;
        change({...values});
    }

    function changeFarDiagnosticRightCylindrical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.rightCylindrical = value;
        change({...values});
    }

    function changeFarDiagnosticRightAxis(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.rightAxis = value;
        change({...values});
    }

    function changeFarDiagnosticRightDNP(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.rightNasoPupillaryDistance = value;
        change({...values});
    }

    function changeFarDiagnosticLeftSpherical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.leftSpherical = value;
        change({...values});
    }

    function changeFarDiagnosticLeftCylindrical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.leftCylindrical = value;
        change({...values});
    }

    function changeFarDiagnosticLeftAxis(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.leftAxis = value;
        change({...values});
    }

    function changeFarDiagnosticLeftDNP(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.farDiagnostic) values.farDiagnostic = new DiagnosticInformation();
        values.farDiagnostic.leftNasoPupillaryDistance = value;
        change({...values});
    }

    function changeNearDiagnosticRightSpherical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.rightSpherical = value;
        change({...values});
    }

    function changeNearDiagnosticRightCylindrical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.rightCylindrical = value;
        change({...values});
    }

    function changeNearDiagnosticRightAxis(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.rightAxis = value;
        change({...values});
    }

    function changeNearDiagnosticRightDNP(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.rightNasoPupillaryDistance = value;
        change({...values});
    }

    function changeNearDiagnosticLeftSpherical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.leftSpherical = value;
        change({...values});
    }

    function changeNearDiagnosticLeftCylindrical(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.leftCylindrical = value;
        change({...values});
    }

    function changeNearDiagnosticLeftAxis(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.leftAxis = value;
        change({...values});
    }

    function changeNearDiagnosticLeftDNP(value: string) {
        if (!values) values = new FormRecipeValues();
        if (!values.nearDiagnostic) values.nearDiagnostic = new DiagnosticInformation();
        values.nearDiagnostic.leftNasoPupillaryDistance = value;
        change({...values});
    }

    function changeLeftEyeHeight(value?: number) {
        if (!values) values = new FormRecipeValues();
        values.leftEyeHeight = value ? value : null;
        change({...values});
    }

    function changeRightEyeHeight(value?: number) {
        if (!values) values = new FormRecipeValues();
        values.rightEyeHeight = value ? value : null;
        change({...values});
    }
};

export {TabDiagnostic};